module.exports = __webpack_public_path__ + "static/media/ky.68e641e9.png";